import {
  CreateScheduleDto,
  GetSchedulesDto,
  ISchedule
} from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';

/* ----------------------------- Get Schedule By Id ----------------------------- */

export const getSchedule = createAction('[Schedules] Get Schedule');

export const getScheduleSuccess = createAction(
  '[Schedules] Get Schedule Success',
  props<{ schedule: ISchedule }>()
);

export const getScheduleFailure = createAction(
  '[Schedules] Get Schedule Failure',
  props<{ error: Error }>()
);

/* ---------------------------- Create Schedule --------------------------- */

export const createSchedule = createAction(
  '[Schedules] Create Schedule',
  props<{
    request: CreateScheduleDto;
  }>()
);

export const createScheduleSuccess = createAction(
  '[Schedules] Create Schedule Success',
  props<{ schedule: ISchedule }>()
);

export const createScheduleFailure = createAction(
  '[Schedules] Create Schedule Failure',
  props<{ error: Error }>()
);

/* ---------------------------- Update Schedule --------------------------- */

export const updateSchedule = createAction(
  '[Schedules] Update Schedule',
  props<{ changes: Partial<ISchedule> }>()
);

export const updateScheduleSuccess = createAction(
  '[Schedules] Update Schedule Success',
  props<{ schedule: ISchedule }>()
);

export const updateScheduleFailure = createAction(
  '[Schedules] Update Schedule Failure',
  props<{ error: Error }>()
);

/* --------------------------- Drawer (edit, add) --------------------------- */

export const closeDrawer = createAction('[Schedules] Close Create Schedule');

/* ----------------------------- cleanActiveSchedule ---------------------------- */

export const setActiveSchedule = createAction(
  '[Schedule] Set Active Schedule',
  props<{ id: string }>()
);

/* ----------------------------- cleanActiveSchedule ---------------------------- */

export const cleanActiveSchedule = createAction(
  '[Schedule] Clean Active Schedule'
);

/* ----------------------------- Sync Schedule ---------------------------- */

export const syncSchedule = createAction(
  '[Schedules] Sync Schedule',
  props<{ id: string }>()
);

export const syncScheduleSuccess = createAction(
  '[Schedules] Sync Schedule Success',
  props<{ id: string; schedule: ISchedule }>()
);

export const syncScheduleFailure = createAction(
  '[Schedules] Sync Schedule Failure',
  props<{ error: Error }>()
);
